var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKoalaIcon = function SvgKoalaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    clipPath: "url(#KoalaIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24 40.236c8.52 0 15.428-6.947 15.428-15.517S32.521 9.203 24 9.203 8.57 16.15 8.57 24.72c0 8.57 6.908 15.517 15.429 15.517"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.428 32.801c0 .791-.361 1.55-1.004 2.11s-1.515.874-2.424.874c-.91 0-1.782-.314-2.425-.874s-1.004-1.319-1.004-2.11v-5.968c0-4.974 3.429-4.974 3.429-4.974s3.428 0 3.428 4.974z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.571 30.563c.961 1.204 2.183 1.822 3.429 1.732 1.245.09 2.468-.528 3.428-1.733M8.416 22.394c-.341.348-.77.586-1.237.685-.466.098-.949.053-1.392-.13-1.251-.468-1.49-2.438-1.043-3.517-.36.55-.897.946-1.512 1.115-.614.169-1.266.1-1.836-.194A3.43 3.43 0 0 1 .27 18.899a3.6 3.6 0 0 1-.237-1.86s0-9.575 6.066-9.575a11.8 11.8 0 0 1 5.123 1.15 12.4 12.4 0 0 1 4.207 3.284M39.584 22.394c.341.349.77.586 1.237.684.465.1.949.054 1.392-.128 1.251-.468 1.49-2.439 1.043-3.518.36.55.897.946 1.511 1.115.615.17 1.267.1 1.837-.193a3.43 3.43 0 0 0 1.126-1.456c.24-.585.322-1.229.237-1.86 0 0 0-9.575-6.066-9.575a11.8 11.8 0 0 0-5.122 1.151 12.4 12.4 0 0 0-4.208 3.283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.069 21.388a.54.54 0 0 1-.535-.543c0-.3.24-.542.535-.542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.068 21.388a.54.54 0 0 0 .535-.543c0-.3-.24-.542-.535-.542M17.476 21.388a.54.54 0 0 1-.535-.543c0-.3.24-.542.535-.542M17.476 21.388a.54.54 0 0 0 .534-.543c0-.3-.24-.542-.534-.542"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "KoalaIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h48v47H0z"
  })))));
};
export default SvgKoalaIcon;